import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo4_Carlos } from '../../../../../utils/ES/Modals/directors';

const ModalVideoCarlos4 = () => {
  return (
    <>
      <ModalVideo
        id="carlos-video-4"
        dataText={TextVideo4_Carlos}
        videoSrc="https://player.vimeo.com/video/651708266?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_CARLOS_4"
      />
    </>
  );
};

export default ModalVideoCarlos4;
